import styled from 'styled-components';

/* ----------------------------------
   Process
----------------------------------- */

export const ProcessSection = styled.section`
  width: 100%;

  padding: var(--space-xxxl) var(--space-xl);

  border-radius: var(--borderRadiusLarge);

  background: var(--grey7);

  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) var(--space-m);
  }
`;

export const SectionHeading = styled.div`
  max-width: 650px;

  ${({ $center }) =>
    $center &&
    `
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    `}

  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(2rem, 3.6vw, 3rem);
    line-height: 1.05;
    font-weight: 900;
    letter-spacing: -0.035em;
  }

  > p:not(.eyebrowHeader) {
    margin: 0;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.75;
    font-weight: 500;
  }
`;

export const ProcessGrid = styled.div`
  margin-top: var(--space-xxxl);

  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media screen and (max-width: 1050px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    margin-top: var(--space-xl);
  }
`;

export const ProcessItem = styled.div`
  padding: var(--space-xl);

  position: relative;

  &:not(:last-child)::after {
    content: '';

    position: absolute;
    right: 0;
    top: 10%;

    width: 1px;
    height: 80%;

    background: rgba(255, 255, 255, 0.1);
  }

  h3 {
    margin: var(--space-l) 0 var(--space-xs);

    color: var(--white);

    font-size: 1.2rem;
    line-height: 1.25;
    font-weight: 900;
  }

  p {
    margin: 0;

    color: var(--grey2);

    font-size: 0.88rem;
    line-height: 1.7;
  }

  @media screen and (max-width: 1050px) {
    &:nth-child(2)::after {
      display: none;
    }

    &:nth-child(-n + 2) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xl) var(--space-xs);

    &:not(:last-child) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    &::after {
      display: none;
    }
  }
`;

export const ProcessNumber = styled.span`
  color: var(--yellow4);

  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0.1em;
`;
